<template lang="pug">
  v-popover(
    :placement='`bottom-${placement}`'
    trigger='manual'
    :delay='{show: 100, hide: 600}'
    :autoHide='false'
    @hide='resetAction'
    @apply-hide='resetAction'
    :open='!!activeAction'
    popoverClass='krea-actions-popover'
    :container='false'
  )
    .actions.row.middle.relative(:class='{[placement]: placement}')
      button.item-1.action(
        v-for='action in filteredActions'
        :key='action.action'
        @click.prevent='setActiveAction(action, $event)'
        v-tooltip.top-start='{content: $t(`krea.kreaActions.${action.action}`), classes: "krea-action-tooltip"}'
      )
        simple-svg.black-icon(:filepath='action.icon' width='20px' height='20px')
    template(slot='popover')
      krea-file-uploader.addon(
        v-if='activeAction === fileType'
        header shadow
        :type='fileType'
        :link='fileLink'
        :updateFile='updateFile'
        :updateLink='updateLink'
        @close='resetAction'
      )
      info.addon(
        v-if='activeAction === "info"'
        :info='info'
        @hideInfo='resetAction'
      )
      insert-link.addon(
        v-if='activeAction === "link"'
        :linkValue='linkValue'
        @updatedLink='updatedLink'
        @removedLink='removedLink'
      )
      comments.addon(
        v-if='activeAction === "comments"'
        :commentsThread='commentsThread'
      )
</template>

<script>
import actions from '@/constants/kreaActions'
import KreaFileUploader from '../KreaFileUploader'
import Info from './Info'
import InsertLink from './Link'
import Comments from './Comments'

export default {
  components: { KreaFileUploader, Info, InsertLink, Comments },
  props: {
    info: { type: Object },
    comments: { type: Boolean },
    edit: { type: Boolean },
    link: { type: Boolean },
    file: { type: Boolean },
    fileValue: { type: String },
    fileType: { type: String },
    fileLink: { type: Boolean },
    removeFile: { type: Boolean },
    updateFile: { type: Function },
    updateLink: { type: Function },
    placement: { type: String, default: 'right' },
    open: { type: Boolean },
    linkValue: { type: String },
    commentsThread: { type: Array },
    kreaContentImage: { type: Boolean }
  },
  data() {
    return {
      actions,
      activeAction: null
    }
  },
  watch: {
    open() {
      this.activeAction = null
    }
  },
  computed: {
    filteredActions() {
      return actions.filter(({ action }) => {
        return (
          this.$props[action] ||
          this.fileType === action ||
          (action === 'removeFile' && this.fileValue) ||
          (action === 'removeFile' && this.linkValue)
        )
      })
    }
  },
  methods: {
    setActiveAction({ action, emit }, event) {
      event.stopPropagation()
      if (emit) {
        this.$emit(action)
      } else if (this.activeAction === action) {
        this.activeAction = null
      } else {
        this.activeAction = action
      }
    },
    resetAction() {
      this.activeAction = null
    },
    updatedLink(value) {
      this.$emit('updatedLink', value)
      this.activeAction = null
    },
    removedLink(value) {
      this.$emit('removedLink', value)
      this.activeAction = null
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.actions{
  display: inline-flex;
  z-index: 5;
  border: 1px solid $black;
  background-color: $white;
  border-radius: 10px;
  height: 35px;
  padding: 0 10px;
  gap: 10px;
  &.right{
    .addon{
      right: 0;
    }
  }
  &.left{
    .addon{
      left: 0;
    }
  }
}

</style>
